import * as React from 'react';

/** Material UI Packages. */
import { TextField, InputAdornment, IconButton } from '@mui/material';

/** Material UI Icons. */
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

/** Search input for filtering todo cards by header, description, opus reference, client, shipper, or consignee. */
export default function TodoSearchBar({ value, onChange }) {
    return (
        <TextField
            fullWidth
            size="small"
            placeholder="Search todo cards..."
            value={value}
            onChange={(event) => onChange(event.target.value)}
            sx={{
                bgcolor: 'white',
                '& .MuiOutlinedInput-root': { fontSize: 12 },
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 16, color: '#7a7a7a' }} />
                    </InputAdornment>
                ),
                endAdornment: value ? (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={() => onChange('')} sx={{ p: '2px' }}>
                            <ClearIcon sx={{ fontSize: 14 }} />
                        </IconButton>
                    </InputAdornment>
                ) : null,
            }}
        />
    );
}
